import { render } from "./Employee.vue?vue&type=template&id=60f85fb1&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"

import "./Employee.vue?vue&type=style&index=0&id=60f85fb1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60f85fb1"

export default script